<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-th-large"> {{ text }} </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import PriorityFilter from "../../filterImplementations/PriorityFilter";
import FilterBadge from "./FilterBadge.vue";
import joinList from "./joinList";

const props = defineProps({
  filter: {
    type: Object as PropType<PriorityFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() => {
  const priorityTexts = props.filter.priorities.map((priority) => {
    return t(`components.eventAction.filter.badges.PriorityFilter.${priority}`);
  });
  return `${t(
    `components.eventAction.filter.badges.PriorityFilter.eisenhowerMatrix`,
  ).toString()} ${joinList(priorityTexts)}`;
});
</script>

<style lang="scss" scoped></style>
